import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { fetch_one, fetch_all } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import InfoIcon from '@mui/icons-material/Info';

import {
  Box,
  Button as Btn,
  Chip,
  CircularProgress,
  DialogActions,
  Grid,
  MenuItem,
  Tooltip,
} from '@mui/material';

import {
  Button,
  DatePicker,
  Dt,
  Editor,
  FileDrop,
  IconButton,
  Select,
  TextInput,
  Typography
} from '../../../../components/v2/styled';

import { Advice } from '../../../../models/Advice';

const { DateTime } = require("luxon");

type Props = {
  onClick: (b:boolean) => void;
  open: boolean;
  setOpen: (b:boolean) => void;
  advice: Advice;
  clonedAdvice: Advice;
  setAdvice: (d:Advice) => void;
  loading?: boolean;
  activeCompare?: Advice;
};

export const CoachEditAdviceTab4: FunctionComponent<Props> = ({activeCompare, loading, open, setOpen, advice, clonedAdvice, setAdvice, onClick}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const {t, i18n} = useTranslation(['translations']);

  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [showHint, setShowHint] = useState<boolean>(false);

  // useEffect(() => {
  //   setFlickerEditor(true);
  //   setTimeout(() => {setFlickerEditor(false);}, 200);
  // }, []);

  return (<>
    {/* <Grid item xs={4}>
      {!flickerEditor && <Editor
        advanced
        label={t("coach.models.advices.comment", "Aantekeningen")}
        value={advice?.comment || ""}
        onChange={(e) => {
          setAdvice({
            ...advice,
            comment: e
          });
        }}
      />}
    </Grid> */}

    <IconButton onClick={() => {
      setShowHint(!showHint);
    }} sx={{
      top: 8,
      position: 'absolute',
      right: 8
    }}>
      <InfoIcon color="primary" />
    </IconButton>
    {showHint && <Grid item xs={12}>
      <Typography html sx={{
        borderRadius: 1,
        border: '1px solid transparent',
        borderColor: theme.palette.warning.main,
        padding: 2,
        textAlign: 'center'
      }}>{t("new_advices.detail.warnings.balloon_wysiwyg")}</Typography>
    </Grid>}

    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_current")}: {advice.identification} (<Dt o={advice.advice_date} />)</Typography>
    </Grid>}
    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_comparison")}: {activeCompare.identification} (<Dt d={activeCompare.advice_date} />)</Typography>
    </Grid>}
    <Grid item xs={!!activeCompare ? 12 : 4} sx={{alignContent: 'baseline'}}>
      <Grid container spacing={1}>
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.breakfast")}
            value={advice?.anamnese?.breakfast || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  breakfast: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.breakfast")}
            value={activeCompare?.anamnese?.breakfast || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.snack1")}
            value={advice?.anamnese?.snack_1 || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  snack_1: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.snack1")}
            value={activeCompare?.anamnese?.snack_1 || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.lunch")}
            value={advice?.anamnese?.lunch || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  lunch: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.lunch")}
            value={activeCompare?.anamnese?.lunch || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.snack2")}
            value={advice?.anamnese?.snack_2 || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  snack_2: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.snack2")}
            value={activeCompare?.anamnese?.snack_2 || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.diner")}
            value={advice?.anamnese?.diner || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  diner: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.diner")}
            value={activeCompare?.anamnese?.diner || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.snack3")}
            value={advice?.anamnese?.snack_3 || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  snack_3: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.snack3")}
            value={activeCompare?.anamnese?.snack_3 || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
      </Grid>
    </Grid>



    <Grid item xs={!!activeCompare ? 12 : 4} sx={{alignContent: 'baseline'}}>
      <Grid container spacing={1}>
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.aversion")}
            value={advice?.anamnese?.aversion || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  aversion: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.aversion")}
            value={activeCompare?.anamnese?.aversion || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.preference")}
            value={advice?.anamnese?.preference || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  preference: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.preference")}
            value={activeCompare?.anamnese?.preference || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={12}>
          <Box sx={{
            border: '1px solid transparent',
            borderColor: theme.palette.primary.main,
            padding: 1,
            marginTop: 1
          }}>
            <Grid container spacing={1}>
              <Grid item xs={!!activeCompare ? 6 : 12}>
                <Typography sx={{fontWeight: 'bold'}}>{t("new_advices.detail.titles.daily_doses")}</Typography>
              </Grid>
              {!!activeCompare &&  <Grid item xs={6}>
                <Typography sx={{fontWeight: 'bold'}}>{t("new_advices.detail.titles.daily_doses")}</Typography>
              </Grid>}
              <Grid item xs={!!activeCompare ? 3 : 6}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  label={t("coach.models.advices.anamnese.daily_grains")}
                  value={advice?.anamnese?.daily_grains || ""}
                  onChange={(e) => {
                    setAdvice({
                      ...advice,
                      anamnese: {
                        ...(advice.anamnese || {}),
                        daily_grains: e
                      }
                    });
                  }}
                />}
              </Grid>
              <Grid item xs={!!activeCompare ? 3 : 6}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  label={t("coach.models.advices.anamnese.daily_fruits")}
                  value={advice?.anamnese?.daily_fruits || ""}
                  onChange={(e) => {
                    setAdvice({
                      ...advice,
                      anamnese: {
                        ...(advice.anamnese || {}),
                        daily_fruits: e
                      }
                    });
                  }}
                />}
              </Grid>
              {!!activeCompare &&  <Grid item xs={3}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  disabled
                  label={t("coach.models.advices.anamnese.daily_grains")}
                  value={activeCompare?.anamnese?.daily_grains || ""}
                  onChange={(e) => {
                    
                  }}
                />}
              </Grid>}
              {!!activeCompare &&  <Grid item xs={3}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  disabled
                  label={t("coach.models.advices.anamnese.daily_fruits")}
                  value={activeCompare?.anamnese?.daily_fruits || ""}
                  onChange={(e) => {
                    
                  }}
                />}
              </Grid>}

              <Grid item xs={!!activeCompare ? 3 : 6}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  label={t("coach.models.advices.anamnese.daily_proteins")}
                  value={advice?.anamnese?.daily_proteins || ""}
                  onChange={(e) => {
                    setAdvice({
                      ...advice,
                      anamnese: {
                        ...(advice.anamnese || {}),
                        daily_proteins: e
                      }
                    });
                  }}
                />}
              </Grid>
              <Grid item xs={!!activeCompare ? 3 : 6}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  label={t("coach.models.advices.anamnese.daily_dairy")}
                  value={advice?.anamnese?.daily_dairy || ""}
                  onChange={(e) => {
                    setAdvice({
                      ...advice,
                      anamnese: {
                        ...(advice.anamnese || {}),
                        daily_dairy: e
                      }
                    });
                  }}
                />}
              </Grid>
              {!!activeCompare &&  <Grid item xs={3}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  disabled
                  label={t("coach.models.advices.anamnese.daily_proteins")}
                  value={activeCompare?.anamnese?.daily_proteins || ""}
                  onChange={(e) => {
                    
                  }}
                />}
              </Grid>}
              {!!activeCompare &&  <Grid item xs={3}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  disabled
                  label={t("coach.models.advices.anamnese.daily_dairy")}
                  value={activeCompare?.anamnese?.daily_dairy || ""}
                  onChange={(e) => {
                    
                  }}
                />}
              </Grid>}

              <Grid item xs={!!activeCompare ? 6 : 12}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  label={t("coach.models.advices.anamnese.daily_veggies")}
                  value={advice?.anamnese?.daily_veggies || ""}
                  onChange={(e) => {
                    setAdvice({
                      ...advice,
                      anamnese: {
                        ...(advice.anamnese || {}),
                        daily_veggies: e
                      }
                    });
                  }}
                />}
              </Grid>
              {!!activeCompare &&  <Grid item xs={6}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  disabled
                  label={t("coach.models.advices.anamnese.daily_veggies")}
                  value={activeCompare?.anamnese?.daily_veggies || ""}
                  onChange={(e) => {
                    
                  }}
                />}
              </Grid>}

              <Grid item xs={!!activeCompare ? 3 : 6}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  label={t("coach.models.advices.anamnese.daily_meats")}
                  value={advice?.anamnese?.daily_meats || ""}
                  onChange={(e) => {
                    setAdvice({
                      ...advice,
                      anamnese: {
                        ...(advice.anamnese || {}),
                        daily_meats: e
                      }
                    });
                  }}
                />}
              </Grid>
              <Grid item xs={!!activeCompare ? 3 : 6}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  label={t("coach.models.advices.anamnese.daily_fats")}
                  value={advice?.anamnese?.daily_fats || ""}
                  onChange={(e) => {
                    setAdvice({
                      ...advice,
                      anamnese: {
                        ...(advice.anamnese || {}),
                        daily_fats: e
                      }
                    });
                  }}
                />}
              </Grid>
              {!!activeCompare &&  <Grid item xs={3}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  disabled
                  label={t("coach.models.advices.anamnese.daily_meats")}
                  value={activeCompare?.anamnese?.daily_meats || ""}
                  onChange={(e) => {
                    
                  }}
                />}
              </Grid>}
              {!!activeCompare &&  <Grid item xs={3}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  disabled
                  label={t("coach.models.advices.anamnese.daily_fats")}
                  value={activeCompare?.anamnese?.daily_fats || ""}
                  onChange={(e) => {
                    
                  }}
                />}
              </Grid>}

              <Grid item xs={!!activeCompare ? 3 : 6}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  label={t("coach.models.advices.anamnese.daily_supplements")}
                  value={advice?.anamnese?.daily_supplements || ""}
                  onChange={(e) => {
                    setAdvice({
                      ...advice,
                      anamnese: {
                        ...(advice.anamnese || {}),
                        daily_supplements: e
                      }
                    });
                  }}
                />}
              </Grid>
              <Grid item xs={!!activeCompare ? 3 : 6}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  label={t("coach.models.advices.anamnese.daily_salts")}
                  value={advice?.anamnese?.daily_salts || ""}
                  onChange={(e) => {
                    setAdvice({
                      ...advice,
                      anamnese: {
                        ...(advice.anamnese || {}),
                        daily_salts: e
                      }
                    });
                  }}
                />}
              </Grid>
              {!!activeCompare &&  <Grid item xs={3}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  disabled
                  label={t("coach.models.advices.anamnese.daily_supplements")}
                  value={activeCompare?.anamnese?.daily_supplements || ""}
                  onChange={(e) => {
                    
                  }}
                />}
              </Grid>}
              {!!activeCompare &&  <Grid item xs={3}>
                {!flickerEditor && <Editor
                  advanced
                  balloon
                  disabled
                  label={t("coach.models.advices.anamnese.daily_salts")}
                  value={activeCompare?.anamnese?.daily_salts || ""}
                  onChange={(e) => {
                    
                  }}
                />}
              </Grid>}

            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Grid>



    <Grid item xs={!!activeCompare ? 12 : 4} sx={{alignContent: 'baseline'}}>
      <Grid container spacing={1}>
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.saturday")}
            value={advice?.anamnese?.saturday || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  saturday: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.saturday")}
            value={activeCompare?.anamnese?.saturday || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.sunday")}
            value={advice?.anamnese?.sunday || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  sunday: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.sunday")}
            value={activeCompare?.anamnese?.sunday || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.weekend_general")}
            value={advice?.anamnese?.weekend_general || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  weekend_general: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.weekend_general")}
            value={activeCompare?.anamnese?.weekend_general || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.pattern")}
            value={advice?.anamnese?.pattern || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  pattern: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.pattern")}
            value={activeCompare?.anamnese?.pattern || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.fluids")}
            value={advice?.anamnese?.fluids || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  fluids: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.fluids")}
            value={activeCompare?.anamnese?.fluids || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
        <Grid item xs={!!activeCompare ? 6 : 12}>
          {!flickerEditor && <Editor
            advanced
            balloon
            label={t("coach.models.advices.anamnese.extra_information")}
            value={advice?.anamnese?.extra_information || ""}
            onChange={(e) => {
              setAdvice({
                ...advice,
                anamnese: {
                  ...(advice.anamnese || {}),
                  extra_information: e
                }
              });
            }}
          />}
        </Grid>
        {!!activeCompare &&  <Grid item xs={6}>
          {!flickerEditor && <Editor
            advanced
            balloon
            disabled
            label={t("coach.models.advices.anamnese.extra_information")}
            value={activeCompare?.anamnese?.extra_information || ""}
            onChange={(e) => {
              
            }}
          />}
        </Grid>}
      </Grid>
    </Grid>
  </>);
}
